var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"align":"center","cols":"12"}},[_c('CartOld',{attrs:{"order":_vm.order}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }